/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
  cards: [],
  isLoading: false
};
export var bankCardsSlice = createSlice({
  name: 'features/bankCards',
  initialState: initialState,
  reducers: {
    initializeBankCards: function initializeBankCards(state, action) {
      state.cards = action.payload;
    },
    showLoader: function showLoader(state, action) {
      state.isLoading = action.payload;
    },
    announceStatus: function announceStatus(state, action) {
      state.status = action.payload;
    },
    resetStatus: function resetStatus(state) {
      state.status = undefined;
    },
    updateSMSCodeValue: function updateSMSCodeValue(state, action) {
      state.sms = action.payload;
    },
    announceError: function announceError(state, action) {
      state.error = action.payload;
    },
    resetError: function resetError(state) {
      state.error = undefined;
    }
  },
  extraReducers: {}
});